
import poHeader from '../assets/img/po/inv-header.gif';
import poSign from '../assets/img/po/inv-apv-sign.gif';
import poFooter from '../assets/img/po/footer.gif';
import angkaTerbilang from '@develoka/angka-terbilang-js';
import Helper from './Helper';
import KwitansiHeader from '../assets/img/po/kwitansi-header.gif';

class MainPrint {
    result;
    MainPrint(id){
        this.id  = id;
    }
    printKwitansi(data, cust, invoice, ret){
        var query = `<style>
        @page {
          /* Add your custom page styles here */
          size: A4; /* or your preferred paper size */
          margin: 50px; /* Adjust margins as needed */
        }
  
        .print-header,
        .print-footer {
          position: relative;
          width: 100%;
          text-align: center;
          repeat:repeat-x;
          
       
        }
  
        .print-header {
          top: 0;
        }
  
        .print-footer {
          bottom: 0;
        }
        .content {
        top:370px;
  
        }
  
        /* Add more styles as needed */
      </style>`
      query += `  <header class="print-header">
        <img src=${KwitansiHeader}  width='100%' alt=''>
          </header><br><br> `
    
    
        query += `<table width='100%' border=0 style="font-family:arial;font-size:10">`;
        query +=`<tr><td colspan='3'>
                <table width="100%" border=0>
                     <tr><td colspan='4' align='left'><h3>NO : ${invoice.kode.split('/')[0]}</td></tr> 
                <tr><td colspan='4' align='center'><h3>KWITANSI</h3></td></tr> 
                <tr><td style='height:10px'></td><td><td></td></td><td></td></tr> 
                <tr><td  style='width:150px'>Sudah diterima dari</td><td>:</td><td style='width:'100%'' colspan=2><b> ` + cust[0].customername.toUpperCase() + `</b></td> </tr> 
                <tr><td>Uang Sebesar</td><td>:</td><td colspan=2> <b>` + angkaTerbilang(Math.ceil(invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) + Math.ceil((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) * (invoice.tax /100))).toUpperCase() + ` RUPIAH</b></td></tr> 
                <tr><td>Untuk Pembayaran</td><td>:</td><td colspan=2> PELUNASAN PAYMENT-` + (parseInt(invoice.kode.split('-')[1].substring(0,1)) + 1).toString() + `  ` +  invoice.persentase +  `% INVOICE : <b>` + invoice.kode  + `</b></td></tr> 
              
                </table>
    
                </td></tr>`
    
        query += `<tr><td colspan='3'><hr></td></tr>`;

        query += `<tr><td colspan='3'><h2>Rp.` + Helper.formatAsCurrency(Math.ceil(invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) + Math.ceil(((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) * (invoice.tax /100)))) +  `,-</h2></td> </tr>`;
        query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
        //var query += "<tr><td colspan='3'><table><tr><td>&nbsp;</td><td>Tanggal:03/14/2024,</br>Tertanda,</td></tr><</table></td> </tr>";
        query += `<tr><td colspan='2' width="80%">&nbsp;</td><td align='center'>Denpasar : ` + this.formatDate(new Date()) + `<br><b>CV. Magnum Solusion</b>,</td> </tr>`;
        query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
        query += `<tr><td colspan='2'>&nbsp;</td><td align='center'>(...............................................................)</td> </tr>`;
        query += `<tr><td colspan='3'><hr></td> </tr>`;
        //query += `<tr><td style='width:250px'>` + new Date().toLocaleString('en-US', { timeZone: 'SINGAPORE', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) + `</td><td  colspan='2'>Printed by : ${name}</td> </tr>`;
        query += `</table>`;
        query += ` <footer class="print-footer">
          <img src=${poFooter} width='100%' alt=''>
          </footer>`

        return query;
    }

    // printInvoice(data, cust, invoice, ret){
    //     var query =`
    //             <html>
    //                 <head>
    //                 <title>${this.id}</title>
    //                 <style>
    //                     @page {
    //                         /* Add your custom page styles here */
    //                         size: A4; /* or your preferred paper size */
    //                         margin: 50px; /* Adjust margins as needed */
    //                     }
  
    //                     .print-header,
    //                     .print-footer {
    //                     position: relative;
    //                     width: 100%;
    //                     text-align: center;
    //                     repeat:repeat-x;
          
       
    //                     }
  
    //     .print-header {
    //       top: 0;
    //     }
  
    //     .print-footer {
    //       bottom: 0;
    //     }
    //     .content {
    //     top:370px;
  
    //     }
  
    //     /* Add more styles as needed */
    //   </style>
    // </head>
    // <body>
  
    //   <header class="print-header">
    //     <img src=${poHeader}  width='100%' alt=''>
    //       </header><br><br> 
    //     <table  class="content" width="100%"   border="0" cellpadding="0" cellspacing="0">
    //     <tr>
    //       <td bgcolor="#CCCCCC">
    //       <table width="100%" border="0" align="center" cellpadding="3" cellspacing="0" style="background-color: #ccc; font-family:arial; font-size:11px;">
    //         <tr>
    //           <td width="60%">
    //             <table width="100%" style="font-size:10">
    //                 <tr>
    //                     <td width="100px"><b>BILL TO</b></td>
    //                     <td><b>${cust[0].customername}</b></td>
    //                 </tr>
    //                 <tr>
    //                     <td>&nbsp;</td>
    //                     <td><b>${cust[0].contactname}</b></td>
    //                 </tr>
    //                 <tr>
    //                     <td>&nbsp;</td>
    //                     <td>${cust[0].address}</td>
    //                 </tr>
    //                 <tr>
    //                     <td>&nbsp;</td>
    //                     <td>${cust[0].customertlp}</td>
    //                 </tr>
    //             </table>
    //           </td>
    //           <td valign="top"> 
    //                  <table width="100%" style="font-size:10">
    //                     <tr>
    //                         <td><b>INVOICE NO </b></td>
    //                         <td>: <b>${invoice.kode}</b></td>
    //                     </tr>
    //                      <tr>
    //                         <td>Date</td>
    //                         <td>: ${Helper.GetDateDDMMYYYY(cust[0].quotationdate)}</td>
    //                     </tr>
    //                      <tr>
    //                         <td>Terms</td>
    //                         <td>: ${cust[0].paymenttermname}</td>
    //                     </tr>
    //                     <tr style="background-color:black;color:white">
    //                         <td>DUE DATE</td>
    //                         <td>: ${Helper.GetDateDDMMYYYY(cust[0].duedate)}</td>
    //                     </tr>
    //                  </table>
    //           </td>
               
              
    //         </tr>
             
    //       </table>
    //       </td>
    //     </tr>
    //   </table><br>
     
  
    //     <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
    //       <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
    //         <td width="5%">&nbsp;</td>
    //         <td width="8%">No</td>
    //         <td width="15%">Part No</td>
    //         <td width="32%">Description</td>
    //         <td width="5%">Qty</td>
    //          <td width="5%">Unit</td>
    //         <td width="9%">Price.</td>
           
    //         <td width="9%">Total</td>
    //       </tr> `
    //       query += data 
          
    //     query += `</table> 
  
    //     <table  style="font-family:arial; font-size:11px;"  width="100%"  border="0" align="center" cellPadding="0" cellSpacing="0">
    //         <tr>
    //             <td colspan="2" style="height:40px">&nbsp;</td>
    //         </tr>
    //         <tr>
    //         <td width="70%">
    //             <table width="100%" style="font-size:10">
    //             <tr>
    //                 <td><b>Note:</b></td>
    //              </tr>
    //              <tr>
    //                 <td><b>-NPWP Register No. 02.788.174.7-907.000 CV. MAGNUM SOLUSION</b></td>
    //              </tr>
    //              <tr>
    //                 <td>&nbsp;</td>
    //              </tr>
    //              <tr>
    //                 <td><b>Bank Account :</b></td>
    //              </tr>
    //              <tr>
    //                 <td>- BRI : 024801002892302 A/N CV. Magnum Solusion</td>
    //              </tr>
    //              <tr>
    //                 <td>&nbsp;</td>
    //              </tr>
    //              <tr>
    //                 <td>if there is a late payment will be subject to a 5% fina;ty per month </td>
    //              </tr>
    //              <tr>
    //                 <td>Let's maintain commitment in doing buiness</td>
    //             </tr>
    //              </table>
    //         </td>
    //         <td>
    //             <table width="100%" style="font-size:10">
    //                 <tr>
    //                     <td width="290px"  style='text-align:left;padding-left:10px'><b>SUB TOTAL</b></td>
    //                     <td  style='text-align:right'><b>${Helper.formatAsCurrency(invoice.total)}</td>
    //                 </tr>`;
    //         if(invoice.persentase == 100 && (ret > 0)){
    //           query +=`<tr>
    //                     <td  style='text-align:left;padding-left:10px'><b>RETENSI ${ret}%</b></td>
    //                     <td  style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total_all * (ret/100)))}</b></td>
    //                 </tr>`;
    //         }   

    //         query +=  ` 
    //                 <tr>
    //                     <td  style='text-align:left;padding-left:10px'><b>TAX ${invoice.tax}%</b></td>
    //                     <td style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100)))* (invoice.tax / 100))) }</b></td>
    //                 </tr>
    //                 <tr>
    //                     <td  style='text-align:left;padding-left:10px'><b>TOTAL</b></td>
    //                     <td style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) + Math.ceil(((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100)))* (invoice.tax / 100))))}</b></td>
    //                 </tr>
    //                 <tr style="background-color:black">
    //                     <td  style='text-align:left;padding-left:10px;color:white'><b>BALANCE DUE</b></td>
    //                     <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) + Math.ceil(((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100)))* (invoice.tax / 100))))}</b></td>
    //                 </tr>
    //             </table>
    //         </td>
             
    //       </tr>
    //     </table>
       
    //     <img src=${poSign} width='100%' alt=''>
  
    //     <footer class="print-footer">
    //       <img src=${poFooter} width='100%' alt=''>
    //       </footer>
  
  
    //     </body></html>
    // `;
    //     return query;
    // }

    printKwitansiV2(data, cust, invoice, ret){
      var query = `<style>
      @page {
        /* Add your custom page styles here */
        size: A4; /* or your preferred paper size */
        margin: 50px; /* Adjust margins as needed */
      }

      .print-header,
      .print-footer {
        position: relative;
        width: 100%;
        text-align: center;
        repeat:repeat-x;
        
     
      }

      .print-header {
        top: 0;
      }

      .print-footer {
        bottom: 0;
      }
      .content {
      top:370px;

      }

      /* Add more styles as needed */
    </style>`
    query += `  <header class="print-header">
      <img src=${KwitansiHeader}  width='100%' alt=''>
        </header><br><br> `
  
  
      query += `<table width='100%' border=0 style="font-family:arial;font-size:10">`;
      query +=`<tr><td colspan='3'>
              <table width="100%" border=0>
                   <tr><td colspan='4' align='left'><h3>NO : ${invoice.kode.split('/')[0]}</td></tr> 
              <tr><td colspan='4' align='center'><h3>KWITANSI</h3></td></tr> 
              <tr><td style='height:10px'></td><td><td></td></td><td></td></tr> 
              <tr><td  style='width:150px'>Sudah diterima dari</td><td>:</td><td style='width:'100%'' colspan=2><b> ` + cust[0].customername.toUpperCase() + `</b></td> </tr> 
              <tr><td>Uang Sebesar</td><td>:</td><td colspan=2> <b>` + angkaTerbilang(Math.ceil(Math.ceil(invoice.total + (invoice.total * ((invoice.tax)/100)))  )).toUpperCase() + ` RUPIAH</b></td></tr> 
              <tr><td>Untuk Pembayaran</td><td>:</td><td colspan=2> PELUNASAN PAYMENT-` + (parseInt(invoice.kode.split('-')[1].substring(0,1)) + 1 ) + `  ` +  invoice.persentase +  `% INVOICE : <b>` + invoice.kode  + `</b></td></tr> 
            
              </table>
  
              </td></tr>`
  
      query += `<tr><td colspan='3'><hr></td></tr>`;

      query += `<tr><td colspan='3'><h2>Rp.` + Helper.formatAsCurrency(Math.ceil(Math.ceil(invoice.total + (invoice.total * ((invoice.tax)/100)))  )) +  `,-</h2></td> </tr>`;
      query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
      //var query += "<tr><td colspan='3'><table><tr><td>&nbsp;</td><td>Tanggal:03/14/2024,</br>Tertanda,</td></tr><</table></td> </tr>";
      query += `<tr><td colspan='2' width="80%">&nbsp;</td><td align='center'>Denpasar : ` + this.formatDate(new Date()) + `<br><b>CV. Magnum Solusion</b>,</td> </tr>`;
      query += `<tr><td colspan='3' style='height:70px'></td> </tr>`;
      query += `<tr><td colspan='2'>&nbsp;</td><td align='center'>(...............................................................)</td> </tr>`;
      query += `<tr><td colspan='3'><hr></td> </tr>`;
      //query += `<tr><td style='width:250px'>` + new Date().toLocaleString('en-US', { timeZone: 'SINGAPORE', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) + `</td><td  colspan='2'>Printed by : ${name}</td> </tr>`;
      query += `</table>`;
      query += ` <footer class="print-footer">
        <img src=${poFooter} width='100%' alt=''>
        </footer>`

      return query;
  }

  printInvoiceV2(data, cust, invoice, ret){
      var query =`
              <html>
                  <head>
                  <title>${this.id}</title>
                  <style>
                      @page {
                          /* Add your custom page styles here */
                          size: A4; /* or your preferred paper size */
                          margin: 50px; /* Adjust margins as needed */
                      }

                      .print-header,
                      .print-footer {
                      position: relative;
                      width: 100%;
                      text-align: center;
                      repeat:repeat-x;
        
     
                      }

      .print-header {
        top: 0;
      }

      .print-footer {
        bottom: 0;
      }
      .content {
      top:370px;

      }

      /* Add more styles as needed */
    </style>
  </head>
  <body>

    <header class="print-header">
      <img src=${poHeader}  width='100%' alt=''>
        </header><br><br> 
      <table  class="content" width="100%"   border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td bgcolor="#CCCCCC">
        <table width="100%" border="0" align="center" cellpadding="3" cellspacing="0" style="background-color: #ccc; font-family:arial; font-size:11px;">
          <tr>
            <td width="60%">
              <table width="100%" style="font-size:10">
                  <tr>
                      <td width="100px"><b>BILL TO</b></td>
                      <td><b>${cust[0].customername}</b></td>
                  </tr>
                  <tr>
                      <td>&nbsp;</td>
                      <td><b>${cust[0].contactname}</b></td>
                  </tr>
                  <tr>
                      <td>&nbsp;</td>
                      <td>${cust[0].address}</td>
                  </tr>
                  <tr>
                      <td>&nbsp;</td>
                      <td>${cust[0].customertlp}</td>
                  </tr>
              </table>
            </td>
            <td valign="top"> 
                   <table width="100%" style="font-size:10">
                      <tr>
                          <td><b>INVOICE NO </b></td>
                          <td>: <b>${invoice.kode}</b></td>
                      </tr>
                       <tr>
                          <td>Date</td>
                          <td>: ${Helper.GetDateDDMMYYYY(cust[0].quotationdate)}</td>
                      </tr>
                       <tr>
                          <td>Terms</td>
                          <td>: ${cust[0].paymenttermname}</td>
                      </tr>
                      <tr style="background-color:black;color:white">
                          <td>DUE DATE</td>
                          <td>: ${Helper.GetDateDDMMYYYY(cust[0].duedate)}</td>
                      </tr>
                   </table>
            </td>
             
            
          </tr>
           
        </table>
        </td>
      </tr>
    </table><br>
   

      <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
        <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
          <td width="5%">&nbsp;</td>
          <td width="8%">No</td>
          <td width="15%">Part No</td>
          <td width="32%">Description</td>
          <td width="5%">Qty</td>
           <td width="5%">Unit</td>
          <td width="9%">Price.</td>
         
          <td width="9%">Total</td>
        </tr> `
        query += data 
        
      query += `</table> 

      <table  style="font-family:arial; font-size:11px;"  width="100%"  border="0" align="center" cellPadding="0" cellSpacing="0">
          <tr>
              <td colspan="2" style="height:40px">&nbsp;</td>
          </tr>
          <tr>
          <td width="70%">
              <table width="100%" style="font-size:10">
              <tr>
                  <td><b>Note:</b></td>
               </tr>
               <tr>
                  <td><b>-NPWP Register No. 02.788.174.7-907.000 CV. MAGNUM SOLUSION</b></td>
               </tr>
               <tr>
                  <td>&nbsp;</td>
               </tr>
               <tr>
                  <td><b>Bank Account :</b></td>
               </tr>
               <tr>
                  <td>- BRI : 024801002892302 A/N CV. Magnum Solusion</td>
               </tr>
               <tr>
                  <td>&nbsp;</td>
               </tr>
               <tr>
                  <td>if there is a late payment will be subject to a 5% fina;ty per month </td>
               </tr>
               <tr>
                  <td>Let's maintain commitment in doing buiness</td>
              </tr>
               </table>
          </td>
          <td>
              <table width="100%" style="font-size:10">
                  <tr>
                      <td width="290px"  style='text-align:left;padding-left:10px'><b>SUB TOTAL</b></td>
                      <td  style='text-align:right'><b>${Helper.formatAsCurrency(invoice.total)}</td>
                  </tr>`;
          // if(invoice.persentase == 100 && (ret > 0)){
          //   query +=`<tr>
          //             <td  style='text-align:left;padding-left:10px'><b>RETENSI ${ret}%</b></td>
          //             <td  style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total_all * (ret/100)))}</b></td>
          //         </tr>`;
          // }   

          query +=  ` 
                  <tr>
                      <td  style='text-align:left;padding-left:10px'><b>TAX ${invoice.tax}%</b></td>
                      <td style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(((invoice.total * ((invoice.tax)/100))) )) }</b></td>
                  </tr>
                  <tr>
                      <td  style='text-align:left;padding-left:10px'><b>TOTAL</b></td>
                      <td style='text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total + (invoice.total * ((invoice.tax)/100)))  )}</b></td>
                  </tr>
                  <tr style="background-color:black">
                      <td  style='text-align:left;padding-left:10px;color:white'><b>BALANCE DUE</b></td>
                      <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency(Math.ceil(invoice.total + (invoice.total * ((invoice.tax)/100)))  )}</b></td>
                  </tr>
              </table>
          </td>
           
        </tr>
      </table>
     
      <img src=${poSign} width='100%' alt=''>

      <footer class="print-footer">
        <img src=${poFooter} width='100%' alt=''>
        </footer>


      </body></html>
  `;
      return query;
  }

  printInvoice(data, cust, invoice, ret, note){
    var subTotal = invoice.total;
   
    var retention = invoice.persentase == 100 ? Math.ceil(invoice.total_all * (ret/100)) : 0
    var tax  = Math.ceil((((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) * ((invoice.tax)/100))) )

    var query =`
            <html>
                <head>
                <title>${this.id}</title>
                <style>
                   .header, .header-space,
                   .footer, .footer-space {
                      height: 100px;
                    }
                .header {
                    position: fixed;
                    top: 0;
                    
                }
                .footer {
                    position: fixed;
                    bottom: 0;
                 }
                .no-page-break {
                  page-break-before: avoid;
                  page-break-inside: avoid;
                }

  </style>
</head>
<body>

    <header class="header-space">
      <img src=${poHeader}  width='100%' alt=''>
    </header> 
    <table width="100%" style="margin-top:50px"   border="0" cellpadding="0" cellspacing="0">
    <tr>
      <td bgcolor="#CCCCCC">
      <table width="100%" border="0" align="center" cellpadding="3" cellspacing="0" style="background-color: #ccc; font-family:arial; font-size:11px;margin-bottom:5px;margin-top:5px;">
        <tr>
          <td width="60%">
            <table width="100%" style="font-size:10">
                <tr>
                    <td width="100px"><b>BILL TO</b></td>
                    <td><b>${cust[0].customername}</b></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td><b>${cust[0].contactname}</b></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>${cust[0].address}</td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>${cust[0].customertlp}</td>
                </tr>
            </table>
          </td>
          <td valign="top"> 
                 <table width="100%" style="font-size:10">
                    <tr>
                        <td><b>INVOICE NO </b></td>
                        <td>: <b>${invoice.kode}</b></td>
                    </tr>
                     <tr>
                        <td>Date</td>
                        <td>: ${Helper.GetDateDDMMYYYY(invoice.date)}</td>
                    </tr>
                     <tr>
                        <td>Terms</td>
                        <td>: ${invoice.payment_term.split('-')[0]}</td>
                    </tr>
                    <tr style="background-color:black;color:white">
                        <td>DUE DATE</td>
                        <td>: ${Helper.GetDateDDMMYYYY(invoice.due_date)}</td>
                    </tr>
                 </table>
          </td>
           
          
        </tr>
         
      </table>
      </td>
    </tr>
  </table><br>
 

    <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
      <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
        <td width="5%">&nbsp;</td>
        <td width="8%">No</td>
        <td width="15%">Part No</td>
        <td width="32%">Description</td>
        <td width="5%">Qty</td>
         <td width="5%">Unit</td>
        <td width="9%">Price.</td>
       
        <td width="9%">Total</td>
      </tr> `
      query += data 
      
    query += `</table> 

    <table  style="font-family:arial; font-size:11px;"  width="100%"  border="0" align="center" cellPadding="0" cellSpacing="0">
        <tr>
            <td colspan="2" style="height:40px">&nbsp;</td>
        </tr>
        <tr>
        <td width="70%">
            <table width="100%" style="font-size:10">
            <tr>
                <td><b>${note.replaceAll("\n","<br/>").replaceAll(" ", "&nbsp;")}</b></td>
             </tr>
              
             </table>
        </td>
        <td>
            <table width="100%" style="font-size:10">
                <tr>
                    <td width="290px"  style='text-align:left;padding-left:10px'><b>SUB TOTAL</b></td>
                    <td  style='text-align:right'><b>${Helper.formatAsCurrency(invoice.total)}</td>
                </tr>`;
                if(invoice.persentase == 100 && (ret > 0)){
                  query +=`<tr>
                            <td  style='text-align:left;padding-left:10px'><b>RETENSI ${ret}%</b></td>
                            <td  style='text-align:right'><b>${Helper.formatAsCurrency(retention)}</b></td>
                        </tr>`;
                }   
               
                query +=  ` 
                        <tr>
                            <td  style='text-align:left;padding-left:10px'><b>TAX ${invoice.tax}%</b></td>
                            <td style='text-align:right'><b>${Helper.formatAsCurrency(tax) }</b></td>
                        </tr>`
              
               query += `
                        <tr>
                            <td  style='text-align:left;padding-left:10px'><b>TOTAL</b></td>
                            <td style='text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax  )}</b></td>
                        </tr>
                        <tr style="background-color:black">
                            <td  style='text-align:left;padding-left:10px;color:white'><b>BALANCE DUE</b></td>
                            <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax  )}</b></td>
                        </tr>`
                if(invoice.pph > 0 && (invoice.pph_value > 0)){
                 query += ` 

                <tr id="pphsection11" style="background-color;visibility:visible">
                   <td  style='text-align:left;padding-left:10px;padding-top:10px'><b>PPH ${invoice.pph}%</b> (not displayed)</td>
                   <td style='text-align:right;padding-top:10px'><b>${Helper.formatAsCurrency(invoice.pph_value) }</b></td>
               </tr>
               <tr id="pphsection12" style="background-color:black;visibility:visible">
                   <td  style='text-align:left;padding-left:10px;color:white'><b>TOTAL (not displayed)</b></td>
                   <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax - parseFloat(invoice.pph_value) )}</b></td>
               </tr>`
      }
              query +=`
            </table>
        </td>
         
      </tr>
    </table>
   
    <img src=${poSign} width='100%' alt=''>

    <div class="footer-space">
    <div align="left"> <br><br>
      <img src=${poFooter} width='100%' alt=''>
    </div>
      
    </div>


    </body></html>
`;
    return query;
}

printInvoiceExisted(data, cust, invoice,ret,note){
   
  var subTotal = invoice.total;
   
  var retention = invoice.persentase == 100 ? Math.ceil(invoice.total_all * (ret/100)) : 0
  var tax  = Math.ceil((((invoice.total - (invoice.total_all * ((invoice.persentase == 100 ? ret : 0)/100))) * ((invoice.tax)/100))) )
  
  var query =`
           <html>
               <head>
               <title>${this.id}</title>
               <style>
                  .header, .header-space,
                  .footer, .footer-space {
                     height: 100px;
                   }
               .header {
                   position: fixed;
                   top: 0;
                   
               }
               .footer {
                   position: fixed;
                   bottom: 0;
                }
               .no-page-break {
                 page-break-before: avoid;
                 page-break-inside: avoid;
               }

 </style>
</head>
<body>

   <header class="header-space">
     <img src=${poHeader}  width='100%' alt=''>
   </header> 
   <table width="100%" style="margin-top:50px"   border="0" cellpadding="0" cellspacing="0">
   <tr>
     <td bgcolor="#CCCCCC">
     <table width="100%" border="0" align="center" cellpadding="3" cellspacing="0" style="background-color: #ccc; font-family:arial; font-size:11px;margin-bottom:5px;margin-top:5px;">
       <tr>
         <td width="60%">
           <table width="100%" style="font-size:10">
               <tr>
                   <td width="100px"><b>BILL TO</b></td>
                   <td><b>${cust[0].customername}</b></td>
               </tr>
               <tr>
                   <td>&nbsp;</td>
                   <td><b>${cust[0].contactname}</b></td>
               </tr>
               <tr>
                   <td>&nbsp;</td>
                   <td>${cust[0].address}</td>
               </tr>
               <tr>
                   <td>&nbsp;</td>
                   <td>${cust[0].customertlp}</td>
               </tr>
           </table>
         </td>
         <td valign="top"> 
                <table width="100%" style="font-size:10">
                   <tr>
                       <td><b>INVOICE NO </b></td>
                       <td>: <b>${invoice.kode}</b></td>
                   </tr>
                    <tr>
                       <td>Date</td>
                       <td>: ${Helper.GetDateDDMMYYYY(invoice.date)}</td>
                   </tr>
                    <tr>
                       <td>Terms</td>
                       <td>: ${invoice.payment_term.split('-')[0]}</td>
                   </tr>
                   <tr style="background-color:black;color:white">
                       <td>DUE DATE</td>
                       <td>: ${Helper.GetDateDDMMYYYY(invoice.due_date)}</td>
                   </tr>
                </table>
         </td>
          
         
       </tr>
        
     </table>
     </td>
   </tr>
 </table><br>


   <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
     <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
       <td width="5%">&nbsp;</td>
       <td width="8%">No</td>
       <td width="15%">Part No</td>
       <td width="32%">Description</td>
       <td width="5%">Qty</td>
        <td width="5%">Unit</td>
       <td width="9%">Price.</td>
      
       <td width="9%">Total</td>
     </tr> `
     query += data 
     
   query += `</table> 

   <table  style="font-family:arial; font-size:11px;"  width="100%"  border="0" align="center" cellPadding="0" cellSpacing="0">
       <tr>
           <td colspan="2" style="height:40px">&nbsp;</td>
       </tr>
       <tr>
       <td width="70%">
           <table width="100%" style="font-size:10">
           <tr>
               <td><b>${note.replaceAll("\n","<br/>").replaceAll(" ", "&nbsp;")}</b></td>
            </tr>
             
            </table>
       </td>
       <td>
           <table width="100%" style="font-size:10">
               <tr>
                   <td width="290px"  style='text-align:left;padding-left:10px'><b>SUB TOTAL</b></td>
                   <td  style='text-align:right'><b>${Helper.formatAsCurrency(invoice.total)}</td>
               </tr>`;
       if(invoice.persentase == 100 && (ret > 0)){
         query +=`<tr>
                   <td  style='text-align:left;padding-left:10px'><b>RETENSI ${ret}%</b></td>
                   <td  style='text-align:right'><b>${Helper.formatAsCurrency(retention)}</b></td>
               </tr>`;
       }   

       query +=  ` 
               <tr>
                   <td  style='text-align:left;padding-left:10px'><b>TAX ${invoice.tax}%</b></td>
                   <td style='text-align:right'><b>${Helper.formatAsCurrency(tax) }</b></td>
               </tr>`
     
      query +=  ` 
               <tr>
                   <td  style='text-align:left;padding-left:10px'><b>TOTAL</b></td>
                   <td style='text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax  )}</b></td>
               </tr>
               <tr style="background-color:black">
                   <td  style='text-align:left;padding-left:10px;color:white'><b>BALANCE DUE</b></td>
                   <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax  )}</b></td>
               </tr>`
      
      if(invoice.pph > 0 && (invoice.pph_value > 0)){
      query += ` 

               <tr id="pphsection21" style="background-color;visibility:visible">
                   <td  style='text-align:left;padding-left:10px;padding-top:10px'><b>PPH ${invoice.pph}%</b> (not displayed)</td>
                   <td style='text-align:right;padding-top:10px'><b>${Helper.formatAsCurrency(invoice.pph_value) }</b></td>
               </tr>
               <tr id="pphsection22" style="background-color:black;visibility:visible">
                   <td  style='text-align:left;padding-left:10px;color:white'><b>TOTAL (not displayed)</b></td>
                   <td style='color:white;text-align:right'><b>${Helper.formatAsCurrency((subTotal - retention) + tax - parseFloat(invoice.pph_value) )}</b></td>
               </tr>`
      }
     
      query += `
           </table>
       </td>
        
     </tr>
   </table>
  
   <img src=${poSign} width='100%' alt=''>

   <div class="footer-space">
   <div align="left"> <br><br>
     <img src=${poFooter} width='100%' alt=''>
   </div>
     
   </div>


   </body></html>
`;
   return query;
}


printDailyJournal(data) {
  console.log(data)
     var query =`
           <html>
               <head>
               <title></title>
               <style>
                  .header, .header-space,
                  .footer, .footer-space {
                     height: 100px;
                   }
               .header {
                   position: fixed;
                   top: 0;
                   
               }
               .footer {
                   position: fixed;
                   bottom: 0;
                }
               .no-page-break {
                 page-break-before: avoid;
                 page-break-inside: avoid;
               }

 </style>
</head>
<body>
 
   <table width="100%" align="center" border="0" cellpadding="4" cellspacing="0">
     <tr style="background-color: #0d47a1; color: #ffffff; font-family:arial; font-size:11px;">
   
       <td width="8%">No</td>
       <td width="15%">Tanggal</td>
       <td width="20%">Kegiatan</td>
       <td width="20%">Hasil/Output</td>
       <td  width="15%">Keterangan</td>
       <td>Customer</td>
       <td>User</td>
     </tr> `
     for(let i=0;i < data.length;i++){
        query += `<tr style='font-family:arial; font-size:10px;'>`
        query += `<td>${data[i].id}</td>`
        query += `<td>${data[i].tanggal}</td>`
        query += `<td style="word-wrap: break-word;">${data[i].kegiatan}</td>`
        query += `<td style="word-wrap: break-word;">${data[i].hasil}</td>`
       
        query += `<td style="word-wrap: break-word;">${data[i].keterangan}</td>`
        query += `<td style="word-wrap: break-word;">${data[i].customer}</td>`
         query += `<td style="word-wrap: break-word;">${data[i].user}</td>`
        query += `</tr>`
     }
     
   query += `</table> 
    </body></html>
`;

return query;
}
    formatDate(value) {
        let date = new Date(value);
        const day = date.toLocaleString('default', { day: '2-digit' });
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return day + ' ' + month + ' ' + year;
    }

    addDays(date, days) {
      const newDate = new Date(date);
      newDate.setDate(date.getDate() + days);
      return newDate;
  }

  NoteTemplate(){
    let note = 
    ` Note :
       - NPWP Register No. 02.788.174.7-907.000  CV. MAGNUM SOLUSION
      
  Bank Account :
       - BRI : 024801002892302 A/N CV. Magnum Solusion

  if there is a late payment will be subject to a 5% finalty per month
  Let's maintain commitment in doing buiness`
    return note;
  }
}


export default MainPrint